import { Layout, Menu } from 'antd'
import * as React from 'react'
import { useState } from 'react'
import { NavLink } from 'react-router-dom'
import { useUser } from 'src/context/UserContext'
import { isAdmin } from 'src/util/Util'
import { adminTabs, demandTabs, supplyTabs } from '../../../constants/sidebarTabs'
import './style.css'

const Sider = Layout.Sider

interface SidebarProps {
    selectedKeys: string[],
}

export const Sidebar: React.FC<SidebarProps> = ({ selectedKeys }) => {

    const { user } = useUser()
    const [collapsed, setCollapsed] = useState(false)

    const paramsDesktop = {
        width: 255,
        collapsedWidth: 90,
        collapsible: true,
        collapsed: collapsed,
        onCollapse: setCollapsed
    }

    const admin = isAdmin(user)

    return (
        <Sider {...paramsDesktop} breakpoint="xxl" className="menuLeft">
            <div className="menuLeft__logo">
                {paramsDesktop.collapsed ? (
                    <div className="menuLeft__logoContainer--collapsed">
                        <img src="/resources/images/mobile_logo.svg" alt="" />
                    </div>
                ) : (
                    <div className="menuLeft__logoContainer">
                        <img src="/resources/images/logo.svg" alt="" />
                    </div>
                )}
            </div>
            <div className="sidebar-scrollbar-handler" style={{ height: 'calc(100vh - 112px)', overflowY: 'scroll' }}>
                <Menu
                    className="sidebar__menu"
                    mode="inline"
                    theme="dark"
                    selectedKeys={selectedKeys}
                >
                    {admin && <Menu.ItemGroup className="sidebar__menu-main" key="supply" title="Supply">
                        {supplyTabs
                            .filter(tab => user && tab.roles.includes(user.role))
                            .map(tab =>
                                <Menu.Item key={tab.key} icon={<tab.icon />}>
                                    {tab.url && <NavLink to={tab.url}>{tab.name}</NavLink>}
                                </Menu.Item>
                            )}
                    </Menu.ItemGroup>}
                    <Menu.ItemGroup className="sidebar__menu-main" key="demand" title="Demand">
                        {demandTabs
                            .filter(tab => user && tab.roles.includes(user.role))
                            .map(tab =>
                                <Menu.Item key={tab.key} icon={<tab.icon />}>
                                    {tab.url && <NavLink to={tab.url}>{tab.name}</NavLink>}
                                </Menu.Item>
                            )}
                    </Menu.ItemGroup>
                    <Menu.ItemGroup className="sidebar__menu-main" key="admin" title="Admin">
                        {adminTabs
                            .filter(tab => user && tab.roles.includes(user.role))
                            .map(tab =>
                                <Menu.Item key={tab.key} icon={<tab.icon />}>
                                    {tab.url && <NavLink to={tab.url}>{tab.name}</NavLink>}
                                </Menu.Item>
                            )}
                    </Menu.ItemGroup>
                </Menu>
            </div>
        </Sider>
    )
}


// WEBPACK FOOTER //
// ./src/component/app/sidebar/Sidebar.tsx